import { $showModal } from "./common.js"
// #ifdef H5
// import {
// 	$getwx
// } from '@/common/wxh5';
// #endif
import geo from "@/common/geo.js"
Array.prototype.remove = function(b) {
  let i = this.indexOf(b)
  if (i > -1) {
    this.splice(i, 1)
    return true
  } else {
    return false
  }
}

Date.prototype.format = function(format) {
  /**
   * @param {String} format 时间日期格式字符串 如：yyyy-MM-dd hh:mm:ss
   */
  var o = {
    "M+": this.getMonth() + 1, //month
    "d+": this.getDate(), //day
    "h+": this.getHours(), //hour
    "m+": this.getMinutes(), //minute
    "s+": this.getSeconds(), //second
    "q+": Math.floor((this.getMonth() + 3) / 3), //quarter
    S: this.getMilliseconds(), //millisecond
  }
  if (/(y+)/.test(format)) format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length))
  for (var k in o)
    if (new RegExp("(" + k + ")").test(format))
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length))
  return format
}

import { v4 as uuidv4 } from "uuid"

function friendlyDate(timestamp) {
  var formats = {
    year: "%n% 年前",
    month: "%n% 月前",
    day: "%n% 天前",
    hour: "%n% 小时前",
    minute: "%n% 分钟前",
    second: "%n% 秒前",
  }

  var now = Date.now()
  var seconds = Math.floor((now - timestamp) / 1000)
  var minutes = Math.floor(seconds / 60)
  var hours = Math.floor(minutes / 60)
  var days = Math.floor(hours / 24)
  var months = Math.floor(days / 30)
  var years = Math.floor(months / 12)

  var diffType = ""
  var diffValue = 0
  if (years > 0) {
    diffType = "year"
    diffValue = years
  } else {
    if (months > 0) {
      diffType = "month"
      diffValue = months
    } else {
      if (days > 0) {
        diffType = "day"
        diffValue = days
      } else {
        if (hours > 0) {
          diffType = "hour"
          diffValue = hours
        } else {
          if (minutes > 0) {
            diffType = "minute"
            diffValue = minutes
          } else {
            diffType = "second"
            diffValue = seconds === 0 ? (seconds = 1) : seconds
          }
        }
      }
    }
  }
  return formats[diffType].replace("%n%", diffValue)
}

export function $friendlyDate(val) {
  return friendlyDate(val * 1000)
}

export function $getLocation() {
  let loc
  alert("未实现$getLocation")
  return
  // return new Promise((resolve, reject) => uni.getLocation({
  // 	success: (res) => {
  // 		loc = {
  // 			latitude: res.latitude,
  // 			longitude: res.longitude
  // 		}
  // 		$setStorage('location', loc)
  // 		console.log("经纬度保存成功...")
  // 		resolve(loc)
  // 	},
  // 	fail: (err) => {
  // 		loc = $getStorage('location')
  // 		if (loc) {
  // 			console.log("获取缓存地址成功...")
  // 			resolve(loc)
  // 		} else {
  // 			console.log("获取地址失败")
  // 			reject(err)
  // 		}
  // 	},
  // }))
}
export function $smallImage(url) {
  return $typeImage(url, "small")
}

function $typeImage(url, type) {
  if (url && url.length > 0) {
    if (url.startsWith("https://") || url.startsWith("http://")) {
      // qiniu
      url = url.replace(/!\S/, "")
      return url + "!" + type
    } else {
      return $buildParam(url, "type", type)
    }
  } else {
    return url
  }
}

export function $isWXH5() {
  return false
}

export function $buildParam(raw, par, par_value) {
  var r = new RegExp("([&?])" + par + "=[^&]*")
  var replaceText = par + "=" + par_value
  var rs = raw.match(r)
  if (rs) {
    return raw.replace(r, rs[1] + replaceText)
  } else {
    if (raw.match("[?]")) {
      return raw + "&" + replaceText
    } else {
      return raw + "?" + replaceText
    }
  }
}

export function $queryParam(data, isPrefix) {
  isPrefix = isPrefix ? isPrefix : false
  let prefix = isPrefix ? "?" : ""
  let _result = []
  for (let key in data) {
    let value = data[key]
    // 去掉为空的参数
    if (["", undefined, null].includes(value)) {
      continue
    }
    if (value.constructor === Array) {
      value.forEach((_value) => {
        _result.push(encodeURIComponent(key) + "[]=" + encodeURIComponent(_value))
      })
    } else {
      _result.push(encodeURIComponent(key) + "=" + encodeURIComponent(value))
    }
  }

  return _result.length ? prefix + _result.join("&") : ""
}

export function $isArrayEqual(a1, a2) {
  /**
   * 判断两个数组中的值是否相等
   */
  if (!Array.isArray(a1) || !Array.isArray(a2)) {
    return false
  }
  if (a1.length != a2.length) {
    return false
  }
  return JSON.stringify(this.$deepCopy(a1).sort()) == JSON.stringify(this.$deepCopy(a2).sort())
}

export function $formatFloat(src, pos = 2) {
  /**
   * 把浮点数转化为保留pos位的浮点数
   * @param src 原浮点数
   * @param pos 保留位数
   */
  if (typeof src !== "number") {
    src = parseFloat(src)
    if (isNaN(src)) {
      return 0
    }
  }
  return src ? Math.round(src * Math.pow(10, pos)) / Math.pow(10, pos) : 0
}

export function $checkIdNum(val) {
  // 校验身份证号
  // 第一位不可能是0
  // 第二位到第六位可以是0-9
  // 第七位到第十位是年份，19或者20
  // 十一位和十二位是月份，这两位是01-12之间的数值
  // 十三位和十四位是日期，是从01-31之间的数值
  // 十五，十六，十七都是数字0-9
  // 十八位可能是数字0-9，也可能是X
  return /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0-9]{2})([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[Xx])$/.test(
    val
  )
}

export function $checkNum(val) {
  // 校验数字
  return /^\d+$/.test(val)
}

export function $checkMoney(val) {
  // 校验价格
  return /^[0-9]+(\.[0-9]{1,5})?$/.test(val)
}
export function $checkPhone(val) {
  return /^\d{1,3}-\d{5,20}$/.test(val)
}
export function $stringLast(s) {
  return s.substr(s.length - 4)
}
export function $checkBankNum(val) {
  // 检验16位到19位银行卡号
  return /^([1-9]{1})(\d{15}|\d{18})$/.test(val)
}

export function $formatStamp(val, fmt) {
  // 格式化时间, fmt参见Date.prototype.format
  if (!val) {
    return ""
  }
  if (val.timestamp) val = val.timestamp
  const tm = new Date(val * 1000)
  if (!fmt) fmt = "yyyy-MM-dd hh:mm:ss"
  return tm.format(fmt)
}
export function $substring(str, end, endStr = "...") {
  return str ? str.substring(0, end) + (str.length > end ? endStr : "") : ""
}
export function $deepCopy(source) {
  return JSON.parse(JSON.stringify(source))
}

export async function $scanCode() {
  return await new Promise((success, reject) => {
    var type = 0
    let onResult = (result, scanType) => {
      let rs = result.split(",")
      if (!scanType) {
        // 类型推测
        scanType = "QR_CODE"
        if (rs.length >= 2) {
          let types = ["EAN_13", "UPC_A", "UPC_C", "CODABAR", "CODE_128", "CODE_25"]
          if (types.includes(rs[0])) {
            scanType = types[0]
            result = result.substr(result.indexOf(",") + 1)
          }
        }
      }
      success({
        scanType,
        result,
      })
    }

    // 普通网页(APP WebView?)
    let r = prompt("请输入测试数据", window.localStorage.scanCode || "")
    setTimeout(() => {
      if (r) {
        window.localStorage.scanCode = r
        onResult(r)
      } else {
        reject("")
      }
    }, 100)
    type = "wap"
  })
}

export async function $sendVerifyPhone(phone, usetype, key) {
  if (!key) key = "codeTimeCounter"
  let timerK = key + "_timer"
  this.$doing()
  let r = await this.$callapi("sendVerifyPhone", {
    phone: phone,
    usetype: usetype || "login",
  })
  this.$done()
  if (r && r.data) {
    var counter = 60
    this.$set(this, key, counter)
    this[timerK] && clearInterval(this[timerK])
    this[timerK] = setInterval(() => {
      --counter
      this.$set(this, key, counter)
      if (this.codeTimeCounter <= 0) {
        clearInterval(this[timerK])
      }
    }, 1000)
    this.$toast(this.$t("验证码已发送到手机{phone}请注意查收!").replace("{phone}", phone), 3000)
  }
  return r
}

export async function $sendVerifyEmail(email, usetype, key) {
  if (!key) key = "codeTimeCounter"
  let timerK = key + "_timer"
  this.$doing()
  let r = await this.$callapi("sendVerifyEmail", {
    email: email,
    usetype: usetype || "login",
  })
  this.$done()
  if (r && r.data) {
    var counter = 60
    this.$set(this, key, counter)
    this[timerK] && clearInterval(this[timerK])
    this[timerK] = setInterval(() => {
      --counter
      this.$set(this, key, counter)
      if (this.codeTimeCounter <= 0) {
        clearInterval(this[timerK])
      }
    }, 1000)
    this.$toast(this.$t("验证码已发送到邮箱{email}请注意查收!").replace("{email}", email), 3000)
  }
  return r
}

export default {
  install(Vue) {
    Vue.prototype.$formatFloat = $formatFloat
    Vue.prototype.$isArrayEqual = $isArrayEqual
    Vue.prototype.$formatStamp = $formatStamp
    Vue.prototype.$formatFloat = $formatFloat
    Vue.prototype.$stringLast = $stringLast
    Vue.prototype.$checkBankNum = $checkBankNum
    Vue.prototype.$checkPhone = $checkPhone
    Vue.prototype.$checkMoney = $checkMoney
    Vue.prototype.$checkNum = $checkNum
    Vue.prototype.$checkIdNum = $checkIdNum
    Vue.prototype.$friendlyDate = $friendlyDate
    Vue.prototype.$nowDateTime = new Date().format("yyyy-MM-dd hh:mm:ss")
    Vue.prototype.$nowDate = new Date().format("yyyy-MM-dd")
    Vue.prototype.$substring = $substring
    Vue.prototype.$deepCopy = $deepCopy
    Vue.prototype.$isWXH5 = $isWXH5

    Vue.prototype.$typeImage = function(url, type) {
      return this.$isTempPath(url) ? url : $typeImage(url, type)
    }
    Vue.prototype.$smallImage = function(url) {
      return this.$isTempPath(url) ? url : $smallImage(url)
    }

    Vue.prototype.$normalImage = function(url) {
      return this.$isTempPath(url) ? url : $typeImage(url, "normal")
    }
    Vue.prototype.$firstImage = function(imgs, type) {
      if (typeof imgs === "string") {
        imgs = imgs.split(";")
      }
      if (imgs && imgs.length) {
        let img = imgs[0]
        if (type) {
          img = this.$typeImage(img, type)
        }
        return img
      }
    }
    Vue.prototype.$queryParam = $queryParam
    Vue.prototype.$scanCode = $scanCode

    // 获取视频封面
    Vue.prototype.$videoImage = function(vurl) {
      return vurl.replace(/#video/, "") + "?vframe/jpg/offset/0"
    }

    Vue.prototype.$sFormatStamp = function(v) {
      return $formatStamp(v, "MM-dd hh:mm")
    }

    Vue.prototype.$sendVerifyPhone = $sendVerifyPhone
    Vue.prototype.$sendVerifyEmail = $sendVerifyEmail

    // 确保obj的fields字段路径都已上传
    Vue.prototype.$isTempPath = function(tmp) {
      return tmp && (tmp.startsWith("http://tmp/") || (!tmp.startsWith("http://") && !tmp.startsWith("https://")))
        ? true
        : false
    }

    Vue.prototype.$getDistance = function(dis) {
      if (!dis) return ""
      return dis < 1 ? "小于1千米" : dis.toFixed(0) + this.$t("千米")
    }

    Vue.prototype.$autoUploads = async function(obj, fields) {
      if (!Array.isArray(fields)) {
        fields = [fields]
      }
      console.log(obj, fields)
      let tmpMap = {}
      let files = []
      fields.map((f) => {
        let tmp = obj[f]
        if (!tmp) return
        if (tmp.includes(";")) {
          // 图片组
          tmp.split(";").map((stmp) => {
            if (stmp && this.$isTempPath(stmp)) {
              if (tmpMap[stmp]) {
                tmpMap[stmp].push(f)
              } else {
                tmpMap[stmp] = [f]
                files.push(stmp)
              }
            }
          })
        } else if (this.$isTempPath(tmp)) {
          // 临时文件
          if (tmpMap[tmp]) {
            tmpMap[tmp].push(f)
          } else {
            tmpMap[tmp] = [f]
            files.push(tmp)
          }
        }
      })
      if (files.length) {
        let ress = await this.$uploadFiles(files)
        ress.forEach((res, i) => {
          tmpMap[files[i]].map((f) => {
            obj[f] = obj[f].split(files[i]).join(res.url)
          })
        })
      }
      return obj
    }
    Vue.prototype.$getImageNames = async function(images) {
			let files = [];
			let imgArr = images.split(';')
			let upfiles = []
			imgArr.map(f => {
				if (f && this.$isTempPath(f)) {
					files.push(f)
				}
			})
			console.log(upfiles);
			if(files.length){
				upfiles  = await this.$uploadFiles(files)
			}
			return upfiles
		}

    Vue.prototype.$startPay = async function(option) {
      if (!this.$refs.readypay) {
        await this.$msg("当前页面没有readypay组件")
      } else {
        let r = await this.$refs.readypay.startPay(option)
        if (r) {
          this.$toast(this.$t("支付成功！"), "success")
        } else {
          this.$toast(this.$t("支付失败"))
        }
        return r
      }
    }

    // 请求订阅消息,在可能发消息的地方调用
    Vue.prototype.$requestSubscribeMessage = function(key) {
      // #ifdef MP-WEIXIN
      // console.log(key);
      return true
    }

    Vue.prototype.$getQRCodeUrl = function(text) {
      return "https://irutils.inruan.com/utils/qrcode?text=" + encodeURIComponent(text)
    }

    Vue.prototype.$getCurrentPath = function(text) {
      let page = this.$getCurrentPage()
      if (!page) return "/pages/home/index"
      let opt = page.options || {}
      var path = page.route
      let param = Object.keys(opt || {})
        .map((k) => {
          return k + "=" + encodeURIComponent(opt[k])
        })
        .join("&")
      if (param) path = path + "?" + param
      if (path[0] != "/") path = "/" + path
      return path
    }

    Vue.prototype.$await = function(fun, param) {
      return new Promise((resolve, reject) => {
        let np = Object.assign({}, param || {})
        np.success = (r) => {
          // console.log('success', fun, r)
          resolve(r)
        }
        np.fail = (e) => {
          console.log("fail", fun, e)
          // e && e.errMsg && showError(e.errMsg)
          reject(e)
        }
        fun(np)
      })
    }

    Vue.prototype.$chooseLocation = async function({ latitude, longitude }) {
      let gcj
      if (latitude && longitude) {
        gcj = geo.wgs84togcj02(longitude, latitude)
      } else {
        gcj = ["", ""]
      }
      /*
			// #ifndef MP-WEIXIN
			let rawRes = await this.$selectData('/pages/utils/choose-location' + '?longitude='+gcj[0]+ '&latitude='+gcj[1])
			// #endif
			// #ifdef MP-WEIXIN
			let rawRes = await this.$await(r=>uni.chooseLocation(r), {
				latitude: gcj[0],
				longitude: gcj[1],
			})
			// #endif
			*/
      alert("未实现_uploadFile")
      return
      // let rawRes = await this.$await(r => uni.chooseLocation(r), {
      // 	latitude: gcj[0],
      // 	longitude: gcj[1],
      // })
      // if (rawRes) {
      // 	let wgsll = geo.gcj02towgs84(rawRes.longitude, rawRes.latitude)
      // 	return {
      // 		longitude: wgsll[0],
      // 		latitude: wgsll[1],
      // 		name: rawRes.name,
      // 		address: rawRes.address || '',
      // 	}
      // }
    }
  },
}
